export function KVList({ rows }: { rows: { k: string; v: React.ReactNode }[] }) {
  return (
    <div className="w-full overflow-hidden rounded-lg border border-line bg-surface">
      {rows.map((row, i) => (
        <div
          key={i}
          className="flex items-center justify-between gap-3 border-b border-line px-3.5 py-2.5 text-xs last:border-b-0"
        >
          <span className="text-muted">{row.k}</span>
          <span className="w-1/2 whitespace-nowrap text-right font-semibold text-ink">{row.v}</span>
        </div>
      ))}
    </div>
  );
}